import React from 'react';
import PropTypes from 'prop-types';
import utils from 'helpers/utils';

class CustomDiscountValueField extends React.Component {
    render() {
        const { elStyle, record } = this.props;

        if (utils.isEmpty(record)) {
            return null;
        }

        if (record.percentage) {
            let value = parseFloat(record.percentage) * 100;

            return <span style={ elStyle }>{ value } %</span>;
        }

        if (record.amount) {
            const currency = record.currency || 'EUR';
            const value = record.amount;
            const locale = this.context.config.language.system;

            return <span style={ elStyle }>{ utils.formatPrice(value, currency, locale) }</span>;
        }
        return null;

    }
}

CustomDiscountValueField.contextTypes = {
    config: PropTypes.object,
};

CustomDiscountValueField.propTypes = {
    elStyle: PropTypes.object,
    record: PropTypes.object,
};

export default CustomDiscountValueField;


// WEBPACK FOOTER //
// ./src/pages/discountCodes/list/CustomDiscountValueField.js